// @flow
import React, { Component, type ComponentType } from "react";
import SpinnerIcon from "@atlaskit/spinner";

import { Spinner } from "./styled";

type Props = {|
    Dialog: ComponentType<any>,
    Photos: ComponentType<any>,
    photoSummary: Object,
    onHide: Function
|};

type State = {
    isLoading: boolean
};

class PhotosDialog extends Component<Props, State> {
    constructor(props) {
        super(props);
        const { photoSummary } = props;
        this.state = {
            isLoading:
                photoSummary == null ||
                photoSummary.photos === null ||
                photoSummary.photos === undefined
        };
    }
    handleClose = () => {
        this.props.onHide();
    };

    render() {
        const { photoSummary, Dialog, Photos } = this.props;
        const { isLoading } = this.state;
        return (
            <Dialog open={photoSummary !== null} onHide={this.handleClose}>
                {photoSummary && (
                    <div style={{ backgroundColor: "#fff" }}>
                        {isLoading ? (
                            <Spinner>
                                <SpinnerIcon
                                    size="medium"
                                    isCompleting={photoSummary.photos != null}
                                    onComplete={() => this.setState({ isLoading: false })}
                                />
                            </Spinner>
                        ) : (
                            <Photos images={photoSummary.photos} />
                        )}
                    </div>
                )}
            </Dialog>
        );
    }
}

export default PhotosDialog;



// WEBPACK FOOTER //
// ./src/photos-dialog/view.js